<!--佣金预测-->
<template>
  <div class="CommissionForecast">
    <app-breadcrumb />
    <div class="page-container">
      <div class="filter">
        <el-form :inline="true" :model="listQuery" label-width="80px" size="mini">
          <!--期数-->
          <el-form-item :label="$t('PoOrder.periodWeek')">
              <!-- 期数起始 -->
              <el-select
                  v-model="listQuery.fromWeek"
                  v-loading="wWeekLoading"
                  :placeholder="this.$t('Start.Period')"
                  filterable
                  style="width: 120px;"
                  clearable
              >
                <el-option v-for="role in listdata" :key="role.id" :label="role.wWeek" :value="role.wWeek" />
              </el-select>
              &nbsp;&nbsp; - &nbsp;&nbsp;
              <!-- 期数结束 -->
              <el-select
                  v-model="listQuery.toWeek"
                  v-loading="wWeekLoading"
                  filterable
                  style="width: 120px;"
                  :placeholder="this.$t('End.Period')"
                  clearable
              >
                <el-option v-for="role in listdata" :key="role.id" :label="role.wWeek" :value="role.wWeek" />
              </el-select>
          </el-form-item>
          <!--总佣金-->
         <el-form-item :label="$t('bd.salaryAll')">
                <el-select v-model="listQuery.bonusAll" style="width: 100px;">
                    <el-option value="" />
                    <el-option v-for="i in compareFlagAlls" :key="i.code"  :label="$lt(initDict.compareFlagAll, i.code)" :value="i.code"/>
                </el-select>
                <el-input v-model.trim="listQuery.bonusAll" style="width: 150px" clearable />
            </el-form-item>
          <el-form-item style="margin-left:10px;">
            <el-button  :loading="btnLoading" type="primary" plain icon="el-icon-search" @click="handleFilter">{{$t('operation.button.search')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table v-loading="loading" :data="list" style="width: 100%" size="mini" border fit stripe>
        <!--期次-->
        <el-table-column :label="$t('PoOrder.periodWeek')" prop="wWeek" align="center" />
        <!--姓名-->
        <el-table-column :label="$t('person.name')" prop="name" align="center" />
        <!--总佣金-->
        <el-table-column :label="$t('bd.salaryAll')" prop="bonusAll" align="center" />
      </el-table>
      <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import {bdPreHisMems} from "@/api/ay-personal-center/personalcenter"

export default {
  name: 'CommissionForecast',
  components: { Pagination },
  data() {
    return {
      btnLoading: false,
      wWeekLoading:false,
      loading: false,
      listdata: [],
      list: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
        fromWeek: '',
        toWeek: ''
      },
      initDict: {
        compareFlagAll: 'type.compare'
       }
    }
  },
  created() {
    this.getWeeks()
    this.listdata = JSON.parse(sessionStorage.getItem('wWeekLocalList'))
  },
    computed: {
        compareFlagAlls() {
            return this.$ll(this.initDict.compareFlagAll)
        },
    },
  methods: {
    getList() {
      this.listLoading = true
      this.btnLoading = true
      this.loading = true
      bdPreHisMems({...this.listQuery}).then(res => {
        this.list = res.data.records
        this.total = +res.data.total
        this.listLoading = false
        this.btnLoading = false
        this.loading = false
      }).catch(() => {
          this.$message.error(this.$t('Query_failed')) // 查询失败
          this.listLoading = false
          this.btnLoading = false
          this.loading = false
      })
    },
    // 查询
    handleFilter() {
      this.getList()
    },
    // 期次
    getWeeks() {
      // this.wWeekLoading = true
      // this.btnLoading = true
      // getChinaWweek1().then(res => {
      //   this.listdata = res.data
      //   this.listQuery.fromWeek = res.data[0].chinaWWeek
      //   this.listQuery.toWeek = res.data[0].chinaWWeek
      //   this.wWeekLoading = false
      //   this.btnLoading = false
      // })
    },
  }
}
</script>

<style>

</style>
